const DEFAULT_LANG = 'en'
const STORAGE_KEY = 'ifg:default-lang'
const AVAILABLE_LANGUAGES = {
  fr: 'fr',
  en: 'gb'
}

function getCurrentLang() {
  return localStorage.getItem(STORAGE_KEY)
}

function setCurrentLang(lang) {
  localStorage.setItem(STORAGE_KEY, lang || DEFAULT_LANG)
}

class Translate {
  constructor({ translations, defaultLang }) {
    this.translations = translations || {}
    this.currentLang = getCurrentLang() || defaultLang
    this.languages = AVAILABLE_LANGUAGES
  }

  static get currentLang() {
    return getCurrentLang()
  }

  static set currentLang(lang) {
    setCurrentLang(lang)
  }

  get currentLang() {
    this.lang = getCurrentLang()
    return this.lang
  }

  set currentLang(lang) {
    this.lang = lang
    setCurrentLang(lang)
  }

  instant(key, opts = {}) {
    if (typeof key === 'object') {
      opts = key
      key = key.translate
    }
    if (!key) throw new Error('Key is not defined')
    const params = opts.translateParams
    const alt = opts.translateAlt
    const lang = opts.translateLang || this.currentLang

    const trads = this.translations[key]
    if (!trads) return alt || key
    const trad = trads[lang]
    if (!trad) return alt || key
    if (!params) return trad
    return trad.replace(/\{\{([^}]+)\}\}/g, (match, capture) => {
      const value = params[capture.trim()]
      return value != null ? value : match
    })
  }
}

export default Translate
